import { validateResponseHasSchema } from '@/shared/api/validation'
import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import { z } from 'zod'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export const fetchYieldActivityLog = (assetCode: string) => validateResponseHasSchema(
  client.sendGet(`assets/${assetCode}/yields/logs`),
  z.object({
    data: z.array(
      z.object({
        userId: z.string(),
        description: z.string(),
        timestamp: z.string().datetime().pipe(z.coerce.date()),
      })
    )
  })
).then(r => r.data)
